import { ConfirmQuestionProps } from "./types";
import styles from "./styles.module.scss";

export default function ConfirmQuestion({
	value = true,
	onChange,
	legend = "Motorista é bilíngue?"
}: ConfirmQuestionProps) {
	const handleChange = (isConfirmed: boolean) => {
		onChange(isConfirmed);
	};

	return (
		<fieldset className={styles.questionFieldset}>
			<legend className={styles.questionLegend}>{legend}</legend>

			<div className={styles.optionsContainer}>
				<label htmlFor="yes" className={styles.radioLabel}>
					<input
						id="yes"
						type="radio"
						name="confirm"
						checked={value === true}
						onChange={() => handleChange(true)}
						className={styles.radioInput}
					/>
					<span className={styles.radioButton} />
					Sim
				</label>

				<label htmlFor="no" className={styles.radioLabel}>
					<input
						id="no"
						type="radio"
						name="confirm"
						checked={value === false}
						onChange={() => handleChange(false)}
						className={styles.radioInput}
					/>
					<span className={styles.radioButton} />
					Não
				</label>
			</div>
		</fieldset>
	);
}
